import { render, staticRenderFns } from "./PaymentResultScreen.vue?vue&type=template&id=d66e7d80"
import script from "./PaymentResultScreen.vue?vue&type=script&lang=js"
export * from "./PaymentResultScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports